import * as React from "react";
import "./PatientLinks.scss";

export interface ServiceLink {
  service: LinkServiceName;
  create?: string;
  read?: string;
  update?: string;
  delete?: string;
}

export enum LinkServiceName {
  SCREENING = "SCREENING",
  MONITORING = "MONITORING",
  CLOUD9 = "CLOUD9",
  GATEWAY = "GATEWAY",
}

interface PatientLinkProps {
  links: ServiceLink[];
}

export default class PatientLinks extends React.PureComponent<PatientLinkProps> {
  render(): React.ReactNode {
    return (
      <div className="container-vertical-dropdown patient-links panel">
        <div className="input-form">
          {this.props.links.map((value, index) => this.getLink(value, index))}
        </div>
      </div>
    );
  }

  private getLink: (link: ServiceLink, index: number) => React.ReactNode = (link, index) => {
    return (
      <div key={index}>
        <span className={"input-name " + (index != 0 ? "space-top" : "")}>
          {i18n[this.getI18nServiceKey(link.service)]}
        </span>
        <span className="input-value space-top-small">
          {link.create && (
            <div>
              <a className="link" href={link.create} target="_blank">
                {i18n["Page.PatientManagement.PatientLink.Service.DisplayLink.Create"]}
              </a>
            </div>
          )}
          {link.read && (
            <div>
              <a className="link" href={link.read} target="_blank">
                {i18n["Page.PatientManagement.PatientLink.Service.DisplayLink.Read"]}
              </a>
            </div>
          )}
          {link.update && (
            <div>
              <a className="link" href={link.update} target="_blank">
                {i18n["Page.PatientManagement.PatientLink.Service.DisplayLink.Update"]}
              </a>
            </div>
          )}
          {link.delete && (
            <div>
              <a className="link" href={link.delete} target="_blank">
                {i18n["Page.PatientManagement.PatientLink.Service.DisplayLink.Delete"]}
              </a>
            </div>
          )}
        </span>
      </div>
    );
  };

  private getI18nServiceKey: (service: LinkServiceName) => string = (service: LinkServiceName) => {
    switch (service) {
      case LinkServiceName.SCREENING:
        return "Page.PatientManagement.PatientLink.Service.Report";
      case LinkServiceName.MONITORING:
        return "Page.PatientManagement.PatientLink.Service.Monitoring";
      case LinkServiceName.CLOUD9:
        return "Page.PatientManagement.PatientLink.Service.Cloud9";
      case LinkServiceName.GATEWAY:
        return "Page.PatientManagement.PatientLink.Service.Gateway";
    }
  };
}
